import { render, staticRenderFns } from "./oilConfirmModal.vue?vue&type=template&id=b141db54&scoped=true&"
import script from "./oilConfirmModal.vue?vue&type=script&lang=js&"
export * from "./oilConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./oilConfirmModal.vue?vue&type=style&index=0&id=b141db54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b141db54",
  null
  
)

export default component.exports